// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"185":"b2e916cf","617":"2853cbb5"}[chunkId] + ".css";
};